<template>
  <div>
    <table class="child-table">
      <thead>
        <tr>
          <th>
            <span class="header-text">{{ 'Thao tác' }}</span>
          </th>
        </tr>
      </thead>
      <tbody v-if="item.status === 'open'">
        <tr>
          <td></td>
        </tr>
        <tr v-for="(item, index) in inventory" :key="index">
          <td style="text-align: center">
            <div class="cursor-pointer" @click="() => openDialog(item)">
              <v-icon size="20" color="primary">mdi-pencil-outline</v-icon>
            </div>
          </td>
        </tr>
      </tbody>
      <PopupEditInventory ref="popupEdit" @onRefresh="() => $emit('onRefresh')" />
    </table>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PopupEditInventory from '../PopupEditInventory.vue'
export default {
  components: { PopupEditInventory },
  computed: {
    ...mapState('importDeliveries', ['inventory', 'item'])
  },
  methods: {
    openDialog(data) {
      this.$refs['popupEdit'].openDialog(data)
    }
  }
}
</script>

<style lang="scss" scoped>
.child-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.child-table th,
.child-table td {
  padding: 12px;
  border-bottom: 1px solid #ddd;
}

.child-table th {
  background-color: #c0d8ff;
  height: 70px;
}

tbody {
  background-color: white;
}

.header-text {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  text-align: center;
}

.child-table td {
  height: 55px;
}
</style>
